import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-black border-t border-yellow-600/20">
      <div className="container mx-auto px-4 sm:px-8 py-8 sm:py-12">
        <div className="bg-zinc-950 rounded-2xl sm:rounded-3xl p-6 sm:p-10 lg:p-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 lg:gap-16 mb-8 sm:mb-12">
            {/* Brand Column */}
            <div className="sm:col-span-2 lg:col-span-1">
              <div className="flex items-center gap-3 mb-4">
                <img
                  src="https://static.readdy.ai/image/dadfa7b8e8bbab8ae3e8df395caac6f8/4d04083fcc989b7aa0d3613feaac88ac.png"
                  alt="Ark Capital"
                  className="h-16 sm:h-20 w-auto"
                />
              </div>
              <div className="text-white text-xs tracking-[0.3em] uppercase mb-4">
                INVEST • BUILD • GROW • LEGACY
              </div>
              <p className="text-white/60 text-sm font-light leading-relaxed">
                Strategic capital deployment in infrastructure, industrial development, and global trade projects that drive sustainable economic growth.
              </p>
            </div>

            {/* Investments Column */}
            <div>
              <h4 className="text-yellow-600 text-xs tracking-[0.2em] uppercase mb-4 sm:mb-6">Investments</h4>
              <ul className="space-y-3">
                {['Infrastructure', 'Industrial', 'Logistics', 'Commodities'].map((item) => (
                  <li key={item}>
                    <a href="#" className="text-white/75 text-sm hover:text-yellow-600 transition-colors cursor-pointer">{item}</a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Company Column */}
            <div>
              <h4 className="text-yellow-600 text-xs tracking-[0.2em] uppercase mb-4 sm:mb-6">Company</h4>
              <ul className="space-y-3">
                <li><a href="#" className="text-white/75 text-sm hover:text-yellow-600 transition-colors cursor-pointer">About</a></li>
                <li><a href="#partnership" className="text-white/75 text-sm hover:text-yellow-600 transition-colors cursor-pointer">Partnerships</a></li>
                <li><a href="#contact" className="text-white/75 text-sm hover:text-yellow-600 transition-colors cursor-pointer">Investor Relations</a></li>
                <li><a href="#portfolio" className="text-white/75 text-sm hover:text-yellow-600 transition-colors cursor-pointer">Portfolio</a></li>
              </ul>
            </div>

            {/* Connect Column */}
            <div>
              <h4 className="text-yellow-600 text-xs tracking-[0.2em] uppercase mb-4 sm:mb-6">Connect</h4>
              <div className="space-y-2 mb-6">
                <div className="text-white/75 text-sm break-all">investors@arkcapitalgroup.net</div>
              </div>
              <div className="flex items-center gap-3">
                {['ri-linkedin-fill', 'ri-twitter-x-fill', 'ri-instagram-fill', 'ri-facebook-fill'].map((icon) => (
                  <a key={icon} href="#" className="inline-flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 border border-yellow-600 text-yellow-600 hover:bg-yellow-600 hover:text-black transition-all duration-300 cursor-pointer">
                    <i className={`${icon} text-lg sm:text-xl`}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="border-t border-yellow-600/20 pt-6 sm:pt-8">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="text-white/50 text-xs text-center sm:text-left">
                © 2025 ARK CAPITAL™. ALL RIGHTS RESERVED.
              </div>
              <div className="flex items-center gap-4 sm:gap-6 text-white/50 text-xs">
                <a href="#" className="hover:text-yellow-600 transition-colors cursor-pointer">Privacy Policy</a>
                <span className="text-yellow-600">|</span>
                <a href="#" className="hover:text-yellow-600 transition-colors cursor-pointer">Terms</a>
                <span className="text-yellow-600">|</span>
                <a href="#" className="hover:text-yellow-600 transition-colors cursor-pointer">Disclosures</a>
              </div>
              <div className="border border-yellow-600 px-4 py-1.5 text-yellow-600 text-xs tracking-wider whitespace-nowrap">
                C-CORPORATION
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
